import React from 'react';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';

import Navbar from '../../Navbar/NavBar';
import PlayerPracticesTab from './PlayerPerformance/PlayerPracticesTab';
import PlayerGamesTab from './PlayerPerformance/PlayerGamesTab';
import TeamPracticesTab from './TeamPerformance/TeamPracticesTab';
import TeamGamesTab from './TeamPerformance/TeamGamesTab';
import { TEAMS_COLORS } from '../../../config/constants/teams';
import { isCC } from '../../../helpers/helpers';
import { FILTER_KEYS, GAMES, PRACTICES } from '../../../config/constants';
import { useDataTeamsState, useUserState } from '../../../store/hooks';
import { useRouter } from '../../../helpers/customHooks';
import { TeamRoutes, TeamsColors } from '../types';

export default () => {
  const user = useUserState();
  const { match, location, history } = useRouter<TeamRoutes>();
  const { dataTeam: team } = useDataTeamsState();
  const currentDate = new Date();
  const filterSeasonData = new URLSearchParams(location.search).get(FILTER_KEYS.DATE_RANGE) || '';
  let filterYear = ((match.params.event === GAMES && currentDate.getMonth() <= 7) ? currentDate.getFullYear() - 1 : currentDate.getFullYear()); 
  try{
    filterYear = JSON.parse(filterSeasonData).year;
  }catch (e){
    console.info('JSON Parse', filterSeasonData);
  }
  if (!team) {
    return <Redirect to={'/teams'} />;
  }
  const changeTab = (tab: string) => {
    const params = history.location.pathname.split('/').slice(0, 4);
    params.push(tab);
    if (user.teamId === team.teamId || isCC(user)) {
      params.push('practices');
      return params.join('/');
    }
    params.push('games');
    return params.join('/');
  };
  return (
    <>
      <Navbar />
      <Container className="container-00">
        <Row>
          <Col lg={12} xs={12}>
            <div className="header-p">
              <Link
                to={{
                  pathname: (location && location.state && location.state.toReturn) || '/teams',
                  search: (location && location.state && location.state.toReturnSearch) || `season=${filterYear}`
                }}
              >
                <img src="/assets/images/sprites/left.svg" alt="" height="15px" className="logo" />
              </Link>
              <div
                className="h-img"
                style={{ backgroundImage: `url("/assets/images/logos/${team.teamAbbrName}.svg")` }}
              />
              <div className="h-g">
                <label className="h-01" style={{ color: `${(TEAMS_COLORS as TeamsColors)[team.teamAbbrName].text}` }}>
                  {team.teamName}
                </label>
                <label className="h-02">
                  <b>{team.totalWins}-{team.totalLoss}-{team.totalTies}</b><span>•</span> {team.divFullName}
                </label>
              </div>
            </div>
            <Tabs
              defaultActiveKey={match.params.tab}
              id="uncontrolled-tab-example"
              mountOnEnter
              unmountOnExit
              onSelect={(e: string | null) => {
                history.push({ pathname: changeTab(e as string), search: location.search, state: location.state });
              }}
            >
              <Tab eventKey="teamPerformance" title="Team Performance">
                {match.params.event === PRACTICES ? <TeamPracticesTab /> : <TeamGamesTab />}
              </Tab>
              <Tab eventKey="playerPerformance" title="Player Performance">
                {match.params.event === PRACTICES ? <PlayerPracticesTab /> : <PlayerGamesTab />}
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </>
  );
};
